import React, { useEffect, useState } from 'react';
import { StaticImage } from "gatsby-plugin-image";
import scrollLock from 'scroll-lock';
import { browser, getLang, getSignupUrl, IS_SERVER } from "../../../../common";
import { translation } from "../../../../translations/bonus30or35/translation";
import ModalRegForm from "../../../templateElements/modalRegForm";
import PartnerLogo from "../../../templateElements/partnerLogo";

const ZenbetBonus = ({ partnerName, brandName, sumValue, currency, lang, langId, promoObject, isRegFormNeeded, countryData, currencyData }) => {
  const [signupUrl, setSignupUrl] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);

  const gatsbySettingsFull = {
    placeholder: 'blurred',
    quality: 60,
    layout: 'fullWidth',
    formats: ["auto"]
  };

  const gatsbySettingsFixed = {
    placeholder: 'blurred',
    quality: 60,
    layout: 'fixed',
    formats: ["auto"]
  };

  const onRegBtnClick = () => {
    setIsModalVisible(true)
    !IS_SERVER && document.querySelector('html').classList.add('lock-window')
    scrollLock.disablePageScroll();
  }

  const closeModal = () => {
    setIsModalVisible(false);
    !IS_SERVER && document.querySelector('html').classList.remove('lock-window')
    scrollLock.enablePageScroll();
  }

  useEffect(() => {
    setSignupUrl(getSignupUrl(brandName, lang));
  }, []);



  return <>
    <StaticImage
      src='../img/zenbet/bg.jpg'
      alt='bg'
      className='bg-img'
      {...gatsbySettingsFull}
    />
    <main>
      <div className="img-wrapper">
        <StaticImage
          src='../img/zenbet/football.png'
          alt='football'
          className={`football wow ${browser().mac ? null : `animate__animated animate__fadeInLeftBig`} `}
          {...gatsbySettingsFixed}
        />
        <StaticImage
          src='../img/zenbet/basketball.png'
          alt='basketball'
          className={`basketball wow ${browser().mac ? null : `animate__animated animate__fadeInRightBig`}`}
          {...gatsbySettingsFixed}
        />
      </div>
      <div className="main-wrapper container">
        {(partnerName && !browser().mobile) ? <PartnerLogo partnerName={partnerName} /> : ''}
        <div className="main-wrapper__content">
          <div dir={lang !== 'ir' ? 'ltr' : 'rtl'} className={`main-wrapper__bonus wow ${browser().mac ? null : `animate__animated animate__headShake`}`}>
            {sumValue}<span>{currency}</span>
          </div>
          <div className="inner-wrapper">
            <StaticImage
              src='../img/zenbet/center-wrapper.png'
              alt='bg'
              className="main-wrapper__bg"
              {...gatsbySettingsFixed}
            />
            <h1 className={`main-wrapper__title main-wrapper__title_${lang} wow ${browser().mac ? null : `animate__animated animate__fadeInRightBig`}`}>
              {getLang(translation, brandName, lang, 'title')}<span>{getLang(translation, brandName, lang, 'titleSpan')}</span>
            </h1>
            {promoObject.promo_code === 'bonus35k'}

            <div className={`main-wrapper__promo wow ${browser().mac ? null : `animate__animated animate__fadeInLeftBig`}`}>
              <span>{getLang(translation, brandName, lang, 'promoSpan')}</span>
              <div className="promo-text">
                {promoObject.promo_code}
              </div>
            </div>

          </div>
          {(partnerName && browser().mobile) ? <PartnerLogo partnerName={partnerName} /> : ''}
          {isRegFormNeeded
            ?
            <button onClick={onRegBtnClick} className={`main-wrapper__btn-get main-wrapper__btn-get_${lang}`}>
              {getLang(translation, brandName, lang, 'btnGet')}
              <span className="border-btn-get" />
            </button>
            :
            <a href={signupUrl} className={`main-wrapper__btn-get main-wrapper__btn-get_${lang}`}>
              {getLang(translation, brandName, lang, 'btnGet')}
              <span className="border-btn-get" />
            </a>
          }
          <ModalRegForm
            isModalVisible={isModalVisible}
            brandName={brandName}
            lang={lang}
            langId={langId}
            defaultCountryId={countryData}
            defaultCurrencyId={currencyData}
            defaultPromoCode={promoObject.promo_code}
            regFormTitle={getLang(translation, brandName, lang, 'regFormTitle')}
            onCloseModal={closeModal}
          />
        </div>
      </div>
    </main>
  </>
}

export default ZenbetBonus

